import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-grid-item-title',
  templateUrl: './grid-item-title.component.html',
  styleUrls: ['./grid-item-title.component.scss']
})
export class GridItemTitleComponent {
  @Input() title: string | undefined;
  @Input() isMediumSize: boolean = false;
  @Input() isBlack: boolean = false;
  @Input() isBold: boolean = false;
  @Input() isSemiBold: boolean = false;
  @Input() spaceBetweenTitleAndTrailing: boolean = false;
}
